import { useState } from "react";

import { PiSparkleBold } from "react-icons/pi";

import { Button } from "@shared/components/ui/Button";
import {
  Drawer,
  DrawerContent,
  DrawerTrigger,
} from "@shared/components/ui/drawer";

import { useSession } from "../auth/hooks/useSession";
import { useUser } from "../auth/hooks/useUser";
import { api } from "../api/services/common/base";
import { DebugCard } from "../debug-drawer/components/debug-card";
import { DebugValue } from "../debug-drawer/components/debug-value";

export const DemoDrawer = () => {
  const user = useUser();
  const { isAdmin } = useSession();
  const [forceDemoEnabled, setForceDemoEnabled] = useState(undefined);

  const isDemoEnabled = forceDemoEnabled ?? isAdmin;

  // @ts-expect-error window is not typed
  window.toggleDemo = () => {
    setForceDemoEnabled(() => !isDemoEnabled);
  };

  // @ts-expect-error window is not typed

  window.hideDemo = () => {
    setForceDemoEnabled(() => false);
  };

  // @ts-expect-error window is not typed
  window.showDemo = () => {
    setForceDemoEnabled(() => true);
  };

  const [isImpersonating, setIsImpersonating] = useState(false);

  const impersonate = async (email) => {
    setIsImpersonating(true);

    try {
      await api.post(`/auth/impersonate`, { email });
      window.location.href = "/app";
    } catch (err) {
      setIsImpersonating(true);
      alert("Error: " + err.message);
    }
  };

  if (!isDemoEnabled || !user) {
    return null;
  }

  return (
    <Drawer>
      <DrawerTrigger asChild>
        <Button className="fixed right-40 bottom-[12px] z-fixed rounded-full !size-[46px] text invisible md:visible">
          <PiSparkleBold className="size-[20px] shrink-0" />
        </Button>
      </DrawerTrigger>
      <DrawerContent className="p-10 flex flex-col gap-3">
        <h2>
          Vous etes connecté en tant que <b>{user.common.type}</b>
        </h2>
        <div className="flex gap-3">
          <Button
            onClick={() => impersonate("contact+nc.midwife@ezyostudio.com")}
            isLoading={isImpersonating}
            disabled={user.username == "contact+nc.midwife@ezyostudio.com"}
          >
            <span>
              Devenir&nbsp;<b>sage-femme</b>
            </span>
          </Button>
          <Button
            onClick={() =>
              impersonate("contact+nc.organization@ezyostudio.com")
            }
            isLoading={isImpersonating}
            disabled={user.username == "contact+nc.organization@ezyostudio.com"}
          >
            <span>
              Devenir&nbsp;<b>une organisation</b>
            </span>
          </Button>
        </div>
        <DebugCard title={user.common.type}>
          {user.userType == "midwife" && (
            <>
              <DebugValue label="ID" value={user.userData.id} />
              <DebugValue label="Email" value={user.common.email} />
            </>
          )}

          {user.userType == "organization" && (
            <>
              <DebugValue label="ID" value={user.userData.name} />
              <DebugValue label="Email" value={user.common.email} />
              <DebugValue label="N° Finess" value={user.userData.finess} />
              <DebugValue label="N° SIRET" value={user.userData.siret} />
            </>
          )}
        </DebugCard>
      </DrawerContent>
    </Drawer>
  );
};
